import type { Ref } from "vue";
import LxcError from "~/core/models/LxcError.class";
import type { Firmware } from "~/modules/firmware/models/Firmware.interface";
import firmwareService from "~/modules/firmware/services/firmware.service";

export function useGetFirmware({
  businessUnitCode,
  organizationCode,
}: {
  businessUnitCode?: number;
  organizationCode?: number;
}) {
  const error: Ref<LxcError | null | undefined> = ref(null);
  const isLoading = ref(false);
  const result: Ref<Firmware | undefined> = ref(undefined);

  function get({
    businessUnitCode,
    organizationCode,
    uuid,
  }: {
    businessUnitCode?: number;
    organizationCode?: number;
    uuid: string;
  }) {
    if (organizationCode) {
      return firmwareService.getOrganizationFirmware({
        organizationCode,
        uuid,
      });
    } else if (businessUnitCode) {
      return firmwareService.getBusinessUnitFirmware({
        businessUnitCode,
        uuid,
      });
    } else {
      throw new Error("business unit or organization code undefined");
    }
  }

  async function getFirmware(uuid: string) {
    isLoading.value = true;
    error.value = undefined;

    const response = await get({ businessUnitCode, organizationCode, uuid });

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    error,
    getFirmware,
    isLoading,
    result,
  };
}
